import { ImageTransformOptions, ImageTransformType } from '@diritto/common/imageKit/constants';

export interface Transformation {
  width?: number | string;
  height?: number | string;
  quality?: number;
  original?: boolean;
  format?: 'jpg' | 'png' | 'gif' | 'webp';
}

export const generateTransOptions = (transformations: Transformation[]) => {
  const options: string[] = [];

  transformations.map(transformation =>
    Object.keys(transformation).map(key => {
      switch (key) {
        case 'width':
          if ('c-at_max' in options) {
            options.push('c-at_max');
          }
          return options.push(`w-${transformation[key]}`);
        case 'height':
          if ('c-at_max' in options) {
            options.push('c-at_max');
          }
          return options.push(`h-${transformation[key]}`);
        case 'quality':
          return options.push(`q-${transformation[key]}`);
        case 'format':
          return options.push(`f-${transformation[key]}`);
        case 'original':
          return options.push(`original`);
        default:
          return options;
      }
    }),
  );

  return options.length > 0 ? `tr:${options.join(',')}` : '';
};

export const generateTransPath = (filePath: string, transformations: Transformation[] = []) => {
  // TODO: gif, webp 변환속도가 느리기 때문에 원본 이미지 응답한다.
  const options = filePath.includes('gif')
    ? generateTransOptions([ImageTransformOptions[ImageTransformType.Original]])
    : generateTransOptions(transformations);
  return options ? `${options}/${filePath}` : filePath;
};
